import PageHeader from "../../components/layout/PageHeader";
import { ProductCard } from "../../components/common/Cards";
import { products } from "../../data/products";

export default function ShopList() {
  return (
    <>
      <PageHeader title="Shop List" crumbs={[{ label: "Shop", to: "/shop-grid" }, { label: "List" }]} />
      <section className="section">
        <div className="container">
          <div className="toolbar">
            <span className="count">Showing all {products.length} products</span>
          </div>
          <div className="grid" style={{ gridTemplateColumns: "1fr" }}>
            {products.map((p) => <ProductCard key={p.id} product={p} list />)}
          </div>
        </div>
      </section>
    </>
  );
}
